/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Integrations_Use_DescInputs */



/**
* | output |
* | --- |
* | "Allows using connected integrations and their tools (n8n, oneGlue, integration tiles) in chats." |
*
* @param {Rights_Cap_Integrations_Use_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_integrations_use_desc = /** @type {((inputs?: Rights_Cap_Integrations_Use_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Integrations_Use_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erlaubt die Nutzung verbundener Integrationen und ihrer Tools (n8n, oneGlue, Integrations-Kacheln) in Chats.")
	return /** @type {LocalizedString} */ ("Allows using connected integrations and their tools (n8n, oneGlue, integration tiles) in chats.")
});